import { FilterService } from './filter.service';
var FilterComponent = /** @class */ (function () {
    function FilterComponent(filterService) {
        this.filterService = filterService;
    }
    return FilterComponent;
}());
export { FilterComponent };
